module.exports = __webpack_public_path__ + "static/media/gallery03.144e1ae2.jpg";